import React from 'react'
import { useTranslation } from 'next-i18next/pages'
import { getBreadcrumbs } from './getBreadcrumbs'
import type { CategoryInterface, Maybe } from '@pylot-data/pylotschema'
import { ProductInterface, CmsPage } from '@pylot-data/fwrdschema'
import { useStoreConfig } from 'config/hooks/useStoreConfig'
import { JsonLdScript } from '../JsonLdScript/JsonLdScript'

type BreadcrumbsProps = {
    product?: Maybe<ProductInterface>
    cmsPage?: Maybe<CmsPage>
    category?: Maybe<CategoryInterface>
    canonicalUrl: string
    titleOverride?: string
}

export const Breadcrumbs = ({
    product,
    category,
    cmsPage,
    canonicalUrl,
    titleOverride
}: BreadcrumbsProps): JSX.Element | null => {
    const { t } = useTranslation(['common'])
    const config = useStoreConfig()

    const breadcrumbItems = getBreadcrumbs({
        product,
        category,
        cmsPage,
        pathname: canonicalUrl,
        t,
        titleOverride,
        config
    })

    if (!product && !category && !cmsPage && canonicalUrl != '') {
        return null
    }

    const breadcrumbData = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbItems
    }

    return breadcrumbItems ? (
        <JsonLdScript id="breadcrumbs-json-ld" data={breadcrumbData} />
    ) : null
}
